import { ResourceManager } from 'devexpress-dashboard';
import { loadMessages, locale } from 'devextreme/localization';
import nbMessages from 'devextreme/localization/messages/nb.json';

const dashboardMessages = require('./messages/dx-dashboard.no.json');
const dashboardNbOverrides = require('./messages/dx-dashboard.no-nb-overrides.json');
const analyticsMessages = require('./messages/dx-analytics-core.no.json');

let applied = false;

/**
 * Applies Norwegian dashboard and DevExtreme UI strings (viewer controls, range filter, date picker).
 * Safe to call multiple times.
 */
export function applyDashboardLocalization() {
    if (applied) {
        return;
    }
    ResourceManager.setLocalizationMessages(dashboardMessages);
    ResourceManager.setLocalizationMessages(dashboardNbOverrides);
    ResourceManager.setLocalizationMessages(analyticsMessages);
    loadMessages(nbMessages);
    locale('nb');
    applied = true;
}
